import { InjectionToken } from '@angular/core';

import { BarLayoutFeature, BarLayoutFeatureKind } from '../bar-layout.feature';

export type BaasLayoutBurgerprofielOptions = {
    _forceBurgerprofiel: boolean;
};

export const BAAS_LAYOUT_BURGERPROFIEL = new InjectionToken<BaasLayoutBurgerprofielOptions>('Layout Burgerprofiel options');

export function withBurgerprofiel(options: Partial<BaasLayoutBurgerprofielOptions>): BarLayoutFeature {
    return {
        kind: BarLayoutFeatureKind.Burgerprofiel,
        providers: [
            {
                provide: BAAS_LAYOUT_BURGERPROFIEL,
                useValue: { _forceBurgerprofiel: false, ...options } as BaasLayoutBurgerprofielOptions
            }
        ]
    };
}
